import { InitData } from '../../server/data/BaseModel';
import { PresentationState } from '../../../dev/gameflow/controller/Presentation';
import { SetupSummary } from './SetupSummary';

export class SetupRestoreSummary extends SetupSummary {

    checkForActivation(data: InitData): boolean { return data.isRestoreState && data.isLastSetupFS }

    // This badboy will define if it is a restore.
    setInitData(data: InitData): void {
        if(data.isRestoreState && data.isLastSetupFS ){
            super.setGamedData(data);
            this.PresentationState.set(PresentationState.ACTIVATED);
        }
    }
}